module.exports = __webpack_public_path__ + "static/img/union.c9d013d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/union.png
// module id = 262
// module chunks = 1